// A replacement for 'flickity-imagesloaded'
export function handleFlickityImageLoading(flickity) {
  const observedImages = new WeakSet()

  const updateCellForImage = image => {
    const cell = flickity.getParentCell(image)

    if (!cell) {
      return
    }

    flickity.cellSizeChange(cell.element)

    if (!flickity.options.freeScroll) {
      flickity.positionSliderAtSelected()
    }
  }

  const observeImage = image => {
    if (observedImages.has(image)) {
      return
    }

    observedImages.add(image)

    image.addEventListener('load', () => updateCellForImage(image))
    image.addEventListener('error', () => updateCellForImage(image))

    // Cached images may already have completed before the listeners were added.
    if (
      image.complete
      && (
        image.currentSrc
        || image.getAttribute('src')
        || image.getAttribute('srcset')
      )
    ) {
      window.requestAnimationFrame(() => {
        if (image.complete) {
          updateCellForImage(image)
        }
      })
    }
  }

  const observeImages = root => {
    if (root instanceof HTMLImageElement) {
      observeImage(root)
      return
    }

    root.querySelectorAll('img').forEach(image => observeImage(image))
  }

  observeImages(flickity.slider)

  return observeImages
}
